// Lib
import Tracking from 'lib/tracking';
import { component } from 'picoapp';

import { setCSSProperty } from 'utils/css';

// Utils
import choozy from 'utils/choozy';
import { repaint } from 'utils/node';
import transitionEnd from 'utils/transition-end';

export default component((node) => {
  let isActive = false;
  const { stlWrapper, stlForm, stlFormInner } = choozy(node);
  const toggles = node.querySelectorAll('[data-stl-form-toggle]');

  const resizeObserver = new ResizeObserver(() => {
    setCSSProperty(node, '--inner-height', `${stlFormInner.offsetHeight}px`);
  });

  resizeObserver.observe(stlFormInner);

  node.addEventListener('click', (event) => Tracking.selectItemCallback(event, false, false));

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      isActive = !isActive;

      if (isActive) {
        stlWrapper.setAttribute('data-active', 'true');

        stlForm.hidden = false;
        repaint(stlForm);

        const focusableSelectors = [
          'a[href]:not([tabindex="-1"]):not([disabled]):not(.hidden)',
          'button:not([tabindex="-1"]):not([disabled]):not(.hidden)',
          'input:not([tabindex="-1"]):not([disabled]):not(.hidden)',
          'select:not([tabindex="-1"]):not([disabled]):not(.hidden)',
          'textarea:not([tabindex="-1"]):not([disabled]):not(.hidden)',
          '[tabindex]:not([tabindex="-1"]):not([disabled]):not(.hidden)',
        ];
        stlForm.querySelector(focusableSelectors.join(', '))?.focus();
      } else {
        stlWrapper.removeAttribute('data-active');

        transitionEnd(stlForm, () => {
          if (!isActive) {
            stlForm.hidden = true;
          }
        });
      }
    });
  });
});
